import React from 'react';
import HeadTittle from '../../../../../../components/HeadTittle';
import ButtonIcon from '../../../../../../components/buttons/ButtonIcon';
import { CleanIcon } from '../../../../../../components/buttons/IconButtons';
import { permissionObj } from '../../../../../../Helpers/permission';
import StepperTabs from "../../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../../components/StepperTabs/StepTab";
import { ButtonNextStep, ButtonPrevStep } from "../../../../../../components/buttons/ButtonNavigation";
import { STEPS_CREATE_SHIFT_ACCESS } from "./Model/Models";
import { AddShiftAccessApp } from "./Functionality/AddShiftAccessApp";
import SectionAccessDevices from "./SubComponents/Steps/SectionAccessDevices";
import SectionAccessDepartments from "./SubComponents/Steps/SectionAccessDepartments";
import SectionCustomAccess from "./SubComponents/Steps/SectionCustomAccess";
import Summary from "./SubComponents/Summary/Summary";

/**
 * @Author: Cecilia López Martínez / Arnulfo Ferro Zapata
 * @JobTitle : Full Stack Developer - IBL
 * Create shift access flow (stepper: devices → departments → custom access → summary).
 */
const AddShiftAccess = () => {

    const {
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        devices, setDevices,
        selectDeleteDevices, setSelectDeleteDevices,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack,
    } = AddShiftAccessApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'}/>

            <StepperTabs
                id={null}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEVICE.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEVICE.INDEX && (
                        <>
                            <SectionAccessDevices
                                id={null}
                                item={item}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                disabled={disabled}
                                handleClearStep={handleClearStep}
                                devices={devices}
                                setDevices={setDevices}
                                selectDeleteDevices={selectDeleteDevices}
                                setSelectDeleteDevices={setSelectDeleteDevices}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_asa_next_devices'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep((prev) => prev + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_SHIFT_ACCESS.ACCESS_DEPARTMENTS.INDEX && (
                        <>
                            <SectionAccessDepartments
                                id={null}
                                handleClearStep={handleClearStep}
                                departments={departments}
                                setDepartments={setDepartments}
                                selectDeleteDepartments={selectDeleteDepartments}
                                setSelectDeleteDepartments={setSelectDeleteDepartments}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_asa_back_departments'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_asa_next_departments'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_SHIFT_ACCESS.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_SHIFT_ACCESS.CUSTOM_ACCESS.INDEX && (
                        <>
                            <SectionCustomAccess
                                id={null}
                                handleClearStep={handleClearStep}
                                user={user}
                                setUser={setUser}
                                selectDeleteUser={selectDeleteUser}
                                setSelectDeleteUser={setSelectDeleteUser}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_asa_back_custom_access'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_asa_next_custom_access'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_SHIFT_ACCESS.SUMMARY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_SHIFT_ACCESS.SUMMARY.INDEX && (
                        <>
                            <Summary
                                t={t}
                                item={item}
                                devices={devices}
                                departments={departments}
                                user={user}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2 mt-3'>
                                <ButtonPrevStep
                                    id='btn_asa_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE)) &&
                                    <ButtonNextStep
                                        id='btn_asa_create_shift_access'
                                        text='create'
                                        click={() => handleAddEdit()}
                                    />
                                }
                            </div>
                        </>
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default AddShiftAccess
